/* eslint-disable */
"use strict";
import errorService from "@/services/errorService";

var config, service;
(async () => {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.service_xml || process.env.VUE_APP_service_documenti;
})();

async function creaXml7Fattura(documento) {
  try {
    const response = await fetch(`${service}/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(documento),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    errorService.onError(error, "aggiornaDocumento");
  }
}

async function creaXml7Multipli(idsDocumenti) {
  try {
    var data = {
      idsDocumenti,
    };
    const response = await fetch(`${service}/create/multipli`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    errorService.onError(error, "aggiornaDocumento");
  }
}

export default {
  creaXml7Fattura,
  creaXml7Multipli,
};
